/**
 * 业务错误码枚举（与后端 ErrorCode.java 保持一致）
 *
 * 分段规则：
 * 1、系统级（与具体业务无关）：自 -1 起递增
 * 2、用户/登录：自 -100 起连续递增
 *
 * 使用示例：
 *   import { ErrorCode, getErrorMessage } from '@/constant/errorCode'
 *   if (res.code === ErrorCode.TOKEN_EXPIRED) { ... }
 *   const msg = getErrorMessage(-103) // "Access token has expired, please refresh it with refreshToken"
 */

export const ErrorCode = {
  // ===== 系统级 =====
  ERROR: -1, // 通用错误
  SYSTEM_BUSY: -2, // 系统繁忙
  TOO_MANY_REQUESTS: -3, // 请求过于频繁
  CONCURRENT_REQUEST: -4, // 并发请求被拒绝

  // ===== 用户/登录 =====
  SMS_CODE_SEND_TOO_FREQUENT: -100, // 验证码发送过于频繁
  SMS_CODE_EXPIRED: -101, // 验证码已过期
  SMS_CODE_ERROR: -102, // 验证码错误
  TOKEN_EXPIRED: -103, // accessToken 已过期（可刷新）
  TOKEN_INVALID: -104, // Token 无效（需重新登录）
  INVALID_USER: -105, // 无效用户（黑名单或已不存在）
  CAPTCHA_EXPIRED: -106, // 图形验证码已过期
  CAPTCHA_ERROR: -107, // 图形验证码错误
  INVALID_MOBILE_NUMBER: -108, // 手机号无效
  TOO_MANY_TIMES: -109, // 短信发送次数超限
  MOBILE_ALREADY_EXISTS: -110, // 手机号已注册
  GOOGLE_TOKEN_INVALID: -111 // 谷歌凭证无效
}

// 错误码对应的默认提示消息
const errorMessages = {
  [-1]: 'error',
  [-2]: 'System busy, please try again later',
  [-3]: 'Too many requests, please try again later',
  [-4]: 'Your request is being processed, please try again later',
  [-100]: 'Verification code has been sent, please try again later',
  [-101]: 'Verification code has expired, please resend',
  [-102]: 'Verification code is incorrect',
  [-103]: 'Access token has expired, please refresh it with refreshToken',
  [-104]: 'Authentication failed, please login again',
  [-105]: 'Invalid User.',
  [-106]: 'Captcha has expired, please refresh',
  [-107]: 'Captcha is incorrect',
  [-108]: 'Invalid mobile number',
  [-109]: 'Too many times.',
  [-110]: 'This mobile number is already registered',
  [-111]: 'Google sign-in failed, please try again'
}

/**
 * 根据错误码获取默认提示消息
 * @param {number} code 错误码
 * @returns {string} 提示消息
 */
export function getErrorMessage (code) {
  return errorMessages[code] || 'Unknown error'
}

/**
 * 判断错误码是否属于 token 相关错误（需要刷新或重新登录）
 * @param {number} code 错误码
 * @returns {boolean}
 */
export function isTokenError (code) {
  return [ErrorCode.TOKEN_EXPIRED, ErrorCode.TOKEN_INVALID, ErrorCode.INVALID_USER].includes(code)
}

/**
 * 判断错误码是否需要执行登出操作
 * @param {number} code 错误码
 * @returns {boolean}
 */
export function shouldLogout (code) {
  return [ErrorCode.INVALID_USER].includes(code)
}

/**
 * 判断错误码是否可以尝试刷新 token
 * @param {number} code 错误码
 * @returns {boolean}
 */
export function canRefresh (code) {
  return code === ErrorCode.TOKEN_EXPIRED
}

export default ErrorCode



// WEBPACK FOOTER //
// ./src/constant/errorCode.js